module.exports = __webpack_public_path__ + "img/error-404.7331d225.svg";